import moment from "moment";
import React from "react";
import {
	TORB3BackendRecord,
	TORB3Record,
} from "../../../../../redux/app/orb3/@types";
import { TORB3GroupC3 } from "../../../../../redux/app/orb3/groups/group-c";
import ORB3TableRows from "../ORB3TableRows";

type OwnProps = {
	orb3Record: TORB3Record | TORB3BackendRecord;
	theme?: "light" | "dark";
};
type ORB3GroupC3PreviewProps = OwnProps;

function ORB3GroupC3Preview(props: ORB3GroupC3PreviewProps) {
	const record = props.orb3Record as TORB3GroupC3;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY",
	);
	const { itemC3 } = record;

	function renderBunkeringDateTime() {
		const stopDTLocal = `${itemC3.startDate}T${itemC3.stopTime}:00${record.timeZone}`;
		const utcStop = moment.utc(stopDTLocal);
		return (
			<h4 className="font-medium uppercase">
				Date Time: {utcStop.format("HH:mm")} hrs UTC on{" "}
				{utcStop.format("DD-MMM-YYYY")} ({itemC3.stopTime} SMT on{" "}
				{moment(itemC3.startDate, "YYYY-MM-DD").format("DD-MMM-YYYY")})
			</h4>
		);
	}

	function renderBunkeringPosition() {
		if (itemC3.bunkeringPositionType === "PORT") {
			return `Port — ${itemC3.bunkeringPortName}`;
		}
		return `Sea — ${itemC3.bunkeringPosition.latitude} / ${itemC3.bunkeringPosition.longitude}`;
	}

	function renderMain() {
		return (
			<ORB3TableRows
				record={record}
				tableRows={[
					[operationDate, "3-C", "3", renderBunkeringDateTime()],
					[null, null, "-", `Bunkering Position: ${renderBunkeringPosition()}`],
					[null, null, "-", `Fuel Type: ${itemC3.fuelType}`],
					[
						null,
						null,
						"-",
						`API Gravity: ${itemC3.apiGravity}, Density at 15°C: ${itemC3.densityAt15c}, Sulphur: ${itemC3.sulphurContent}`,
					],
					[
						null,
						null,
						"-",
						itemC3.supplierDetails ? `Supplier: ${itemC3.supplierDetails}` : "",
					],
					[
						null,
						null,
						"-",
						itemC3.bunkerDeliveryDetails
							? `Bunker Delivery: ${itemC3.bunkerDeliveryDetails}`
							: "",
					],
					[
						null,
						null,
						"-",
						itemC3.receiptNumber ? `Receipt No: ${itemC3.receiptNumber}` : "",
					],
					[null, null, "NOTE", record.remarks],
				]}
				theme={props.theme}
			/>
		);
	}

	return renderMain();
}

export default ORB3GroupC3Preview;
